import { configure, extend } from "vee-validate";

import { digits, email, length, max, min, numeric, regex, required, required_if } from "vee-validate/dist/rules.umd.js";

extend("digits", {
  ...digits,
  message: "This field must be {length} digits long"
});

extend("email", {
  ...email,
  message: "This field must be a valid email"
});

extend("length", {
  ...length,
  message: "This field must be {length} characters"
});

extend("max", {
  ...max,
  message: "This field must be {length} characters or less"
});

extend("min", {
  ...min,
  message: "This field must be {length} characters or more"
});

extend("numeric", {
  ...numeric,
  message: "This field must only include numbers"
});

extend("phone", {
  ...min,
  message: "Must be 10 digits, in ###-###-#### format"
});

extend("phoneCheck", {
  ...regex,
  message: "Must be 10 digits, cannot start with 0 or 1"
});

extend("required", {
  ...required,
  message: "This field is required"
});

extend("required_if", {
  ...required_if,
  message: "One of these fields is required"
});

extend("slug", {
  message: "This field must contain URL-safe characters only",
  validate: value => value.match(/^[A-z0-9@!#$%&*()\-_=+]*$/)
});

extend("regex", {
  ...regex,
  message: "This field should contain a valid Regular Expression",
  validate(value) {
    try {
      var x = new RegExp(value);
      if (x) return true;
    } catch (e) {
      return false;
    }
  }
});

configure({
  classes: {
    valid: "is-valid",
    invalid: "is-invalid"
  }
});
